// src/components/shared/SEO.js
// Tüm SEO meta taglarını tek bir yerden yönetir
// Google, Facebook, Twitter ve yapılandırılmış veri (JSON-LD) desteği

import { Helmet } from "react-helmet-async";

export default function SEO({ settings, lang }) {
  const name     = settings?.name     || "Dursun İnel";
  const titleTr  = settings?.title_tr || "Frontend Manager & Developer";
  const titleEn  = settings?.title_en || "Frontend Manager & Developer";
  const descTr   = settings?.desc_tr  || "2020'dan bu yana web geliştirme alanında aktif olarak çalışıyorum. HTML, CSS, JavaScript ve React ile kullanıcı deneyimini ön planda tutan projeler üretiyorum.";
  const descEn   = settings?.desc_en  || "I have been actively working in web development since 2020. I build projects prioritizing user experience with HTML, CSS, JavaScript and React.";
  const email    = settings?.email    || "inl.dursun@gmail.com";
  const linkedin = settings?.linkedin || "https://linkedin.com/in/dursun-inel";
  const github   = settings?.github   || "https://github.com/dursuninel";

  const siteUrl  = "https://dursuninel.com";
  const title    = lang === "en" ? `${titleEn} - ${name}` : `${titleTr} - ${name}`;
  const desc     = lang === "en" ? descEn : descTr;
  const ogImage  = `${siteUrl}/og-image.png`; // public/ klasörüne eklenecek

  // JSON-LD yapılandırılmış veri — Google'ın kişi kartı oluşturmasını sağlar
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": name,
    "jobTitle": lang === "en" ? titleEn : titleTr,
    "description": desc,
    "url": siteUrl,
    "email": email,
    "sameAs": [linkedin, github].filter(Boolean),
    "knowsAbout": ["HTML", "CSS", "JavaScript", "React", "Node.js", "Firebase", "Web Development"],
    "worksFor": {
      "@type": "Organization",
      "name": "Digimondi Dijital Ajans"
    }
  };

  return (
    <Helmet>
      {/* ── Temel ── */}
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={desc} />
      <meta name="author" content={name} />
      <meta name="keywords" content="frontend developer, web tasarım, yazılım geliştirme, React, JavaScript, İstanbul, web geliştirme, frontend manager" />
      <link rel="canonical" href={siteUrl} />

      {/* ── Open Graph (Facebook, LinkedIn, WhatsApp önizlemesi) ── */}
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={siteUrl} />
      <meta property="og:title"       content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:image"       content={ogImage} />
      <meta property="og:locale"      content={lang === "tr" ? "tr_TR" : "en_US"} />
      <meta property="og:site_name"   content={name} />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image"       content={ogImage} />

      {/* ── Teknik ── */}
      <meta name="robots"   content="index, follow" />
      <meta name="theme-color" content="#0a0a0a" />

      {/* ── JSON-LD yapılandırılmış veri ── */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
}
